// Consultations auth session (sessionStorage).
//
// Shares the same underlying storage key as Partner-Pharmacies so a user
// who unlocks either tool is automatically authenticated for the other —
// both are gated by the same PIN + password.
const KEY = "pp_auth_token";

export const setToken = (t) => sessionStorage.setItem(KEY, t);
export const getToken = () => sessionStorage.getItem(KEY) || "";
export const clearToken = () => sessionStorage.removeItem(KEY);
export const isAuthed = () => !!sessionStorage.getItem(KEY);
